import { render, staticRenderFns } from "./OptionCardSelector.vue?vue&type=template&id=380bf62e&scoped=true&"
import script from "./OptionCardSelector.vue?vue&type=script&lang=ts&"
export * from "./OptionCardSelector.vue?vue&type=script&lang=ts&"
import style0 from "./OptionCardSelector.vue?vue&type=style&index=0&id=380bf62e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380bf62e",
  null
  
)

export default component.exports